// theme.emailValidation
theme.emailValidation = function($this) {
  var count = 0;
  var parent = $this.closest(".form-wrap");
  if ($this.val() == "" || $.trim($this.val()) == '') {
    parent.find('.form-error').text('This field is required').addClass("active");
    var count = 1;
  } else {
    function ValidateEmail(email) {
      var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      return expr.test(email);
    };
    if (!ValidateEmail($this.val())) {
      parent.find('.form-error').text('Please enter valid email').addClass("active");
      var count = 1;
    } else {
      parent.find('.form-error').removeClass("active");
    }
  }
  return count;
}
//theme.fieldValidation
theme.fieldValidation = function($this) {
  var count = 0;
  var parent = $this.closest(".form-wrap");
  var passwordMinlength = parseInt($this.attr("minlength"));
  if($this.val().length > 0 && $this.val().length < passwordMinlength){
    parent.find('.form-error').text('Please enter minimum '+passwordMinlength+' !').addClass("active");
    count = 1;
  } else {
    if ($this.val() == "" || $.trim($this.val()) == '') {
      parent.find('.form-error').text('This field is required').addClass("active");
      count = 1;
    }  else {
      parent.find('.form-error').removeClass("active");
    }
  }
  return count;
}
//theme.nameValidation
theme.nameValidation = function($this) {
  var count = 0;
  var parent = $this.closest(".form-wrap");
  var regex = new RegExp("^[a-zA-Z ]+$");
  var str = $this.val();
  if ($this.val() == "" || $.trim($this.val()) == '') {
    parent.find('.form-error').text('This field is required').addClass("active");
    count = 1;
  } else if ($this.length > 0) {
    if ($this.val().length > 49) {
      if ($this.val().length > 49) {
        parent.find(".form-error").text('First name is too long (maximum is 50 characters)').addClass("active");
      } else {
        parent.find(".form-error").text('First name is too long (maximum is 50 characters)').removeClass("active");
      }
    } else {
      parent.find(".form-error").text('First name is too long (maximum is 50 characters)').removeClass("active");
      if (regex.test(str)) {
        parent.find(".form-error").text('Please Enter Alphabets').removeClass("active");
      } else {
        parent.find(".form-error").text('Please Enter Alphabets').addClass("active");
        count = 1;
      }
    }
  } else {
    parent.find(".form-error").removeClass("active");
  }
  return count;
}
// theme.zipValidation
theme.zipValidation = function($this) {
  var count = 0;
  var parent = $this.closest(".form-wrap");
  var numbers = /^[A-Za-z0-9_]+$/;
  let targetEl = $this.val().length;
  if (!$this.val().match(numbers)) {
    parent.find('.form-error').text('Please Enter valid Zipcode').addClass("active");
    count = 1;
  } else {
    if (targetEl < 3) {
      parent.find(".form-error").text('Please Enter minimum 3 characters').addClass("active");
      count = 1;
    } else if (targetEl > 8) {
      parent.find(".form-error").text('Please Enter maximum 8 characters').addClass("active");
      count = 1;
    } else {
      parent.find(".form-error").removeClass("active");
    }
  }
  return count;
}
// theme.phoneValidation
theme.phoneValidation = function($this) {
  var count = 0;
  var parent = $this.closest(".form-wrap");
  let targetEl = $this.val().length;
  var numbers = /^[0-9]+$/;
  if ($this.val() == "" || $.trim($this.val()) == '') {
      parent.find('.form-error').text('This field is required').addClass("active");
      count = 1;
  } else{
      if (!$this.val().match(numbers)) {
        parent.find(".form-error").text('Please Enter only number').addClass("active");
        return false;
        count = 1;
      } else {
        if (targetEl < 9) {
          parent.find(".form-error").text('Please Enter minimum 9 characters').addClass("active");
          count = 1;
        } else if (targetEl > 14) {
          parent.find(".form-error").text('Please Enter maximum 14 characters').addClass("active");
          count = 1;
        } else {
          parent.find(".form-error").removeClass("active");
        }
      }
  }
  return count;
}
// theme.countryValidation
theme.countryValidation = function($this){
  var count = 0;
  var parent = $this.closest(".form-wrap");
  if ($this.val() == '---') {
    parent.find(".form-error").text('Please select country').addClass("active");
    count = 1;
  }else{
    parent.find(".form-error").text('Please select country').removeClass("active");
  }
  return count;
}
theme.fieldtextareaValidation = function ($this) { 
  var count = 0;
  var parent = $this.closest(".form-wrap");
  var words = $.trim($this.val()).split(" ").length;
  if ($this.val() == "" || $.trim($this.val()) == '') {
    parent.find('.form-error').text('This field is required').addClass("active");
    count = 1;
  }else{
    if (words > 4100 ) {
      parent.find('.form-error').text('You can not use more than 4100 characters').addClass("active");
      return false;
      count = 1;
    } else{
      parent.find('.form-error').removeClass("active");
    }
  } 
  return count;
} 
// theme.formValidation
theme.formValidation = function() {
  $(".form_email").bind("keypress keyup keydown", function(e) {
    if (e.which == 32) {
      return false;
    }
    if ($(this).closest(".form-wrap").find(".form-error.active").length > 0) {
      $(this).closest(".form-wrap").find(".form-error.active").removeClass("active");
    }
  });
  $(".form_field").bind("keypress keyup keydown", function(e) {
    if (e.which == 32) {
      return false;
    }
    theme.fieldValidation($(this));
  });
  $('.form_name').bind("keyup",function(e) {
    theme.nameValidation($(this));
  });
  $(".form_zip").bind("keypress keyup keydown", function(e) {
    theme.zipValidation($(this));
  });

  $(".form_phone").bind("keypress keyup keydown", function(e) {
    theme.phoneValidation($(this));
  });
   $(".form_zip").on('keypress keyup keydown', function(e) {
    theme.zipValidation($(this));
  });
    $(".form_required").on('keypress keyup keydown', function(e) {
    theme.fieldValidation($(this));
  });
};
// theme.submitEvent
theme.submitEvent = function() {
  
	$('#customer_login').submit(function(e) {
    var error_count = 0;
    error_count = error_count + theme.emailValidation($(this).find('[name="customer[email]"]'));
    error_count = error_count + theme.fieldValidation($(this).find('[name="customer[password]"]'));
    if (error_count > 0) {
      e.preventDefault();
      return false;
    }
  });
  
    $('#create_customer').submit(function(e) {
      var error_count = 0;
      error_count = error_count + theme.emailValidation($(this).find('[name="customer[email]"]'));
      error_count = error_count + theme.fieldValidation($(this).find('[name="customer[password]"]'));
      error_count = error_count + theme.nameValidation($(this).find('[name="customer[first_name]"]'));
      error_count = error_count + theme.nameValidation($(this).find('[name="customer[last_name]"]'));
      var $this = $(this);
      if ($this.find('[name="customer[conditions]"]').prop('checked') == false) {
        var parent = $this.find('[name="customer[conditions]"]').closest('.form-wrap');
        parent.find('.form-error').text('Please accept terms and conditions').addClass("active");
        error_count++;
      }
      if (error_count > 0) {
         e.preventDefault();
        return false;
      }
    });
  	 $('.recovery-form-login').submit(function (e) {
      var error_count = 0;
      error_count = error_count + theme.emailValidation($(this).find('#RecoverEmail'));
      if (error_count > 0) {
        return false;
      }
    });

    $('.contact-form').submit(function (e) {
      var error_count = 0;
      error_count = error_count + theme.nameValidation($(this).find('[name="contact[Name]"]'));
      error_count = error_count + theme.emailValidation($(this).find('[name="contact[email]"]'));
      error_count = error_count + theme.phoneValidation($(this).find('[name="contact[Phone number]"]'));
      error_count = error_count + theme.fieldValidation($(this).find('[name="contact[Comment]"]'));

      if (error_count > 0) {
        return false;
      }
    });
    $('#address_form_edit, #address_form_new').submit(function(e) {
      var error_count = 0;
      error_count = error_count + theme.nameValidation($(this).find('[name="address[first_name]"]'));
      error_count = error_count + theme.nameValidation($(this).find('[name="address[last_name]"]'));
      error_count = error_count + theme.fieldValidation($(this).find('[name="address[address1]"]'));
      error_count = error_count + theme.fieldValidation($(this).find('[name="address[address2]"]'));
      error_count = error_count + theme.nameValidation($(this).find('[name="address[city]"]'));
      error_count = error_count + theme.countryValidation($(this).find('[name="address[country]"]'));
      error_count = error_count + theme.zipValidation($(this).find('[name="address[zip]"]'));
      error_count = error_count + theme.phoneValidation($(this).find('[name="address[phone]"]'));
      if (error_count > 0) {
        return false;
      }
    });
	//footer newsletter
  	$('.footer__newsletter').submit(function(e){
		var error_count = 0;
      error_count = error_count + theme.nameValidation($(this).find('[name="contact[firstname]"]'));
      error_count = error_count + theme.nameValidation($(this).find('[name="contact[lastname]"]'));
      error_count = error_count + theme.emailValidation($(this).find('[name="contact[email]"]'));
      if (error_count > 0) {
        return false;
      }
	});
	$(document).submit('form.new-review-form' ,function (e) {
              var error_count = 0;
			  error_count = error_count + theme.nameValidation($(this).find('[name="author"]'));
              error_count = error_count + theme.emailValidation($(this).find('[name="email"]'));
              error_count = error_count + theme.fieldValidation($(this).find('[name="reviewRating"]'));
			  error_count = error_count + theme.nameValidation($(this).find('[name="reviewTitle"]'));
              error_count = error_count + theme.fieldtextareaValidation($(this).find('[name="reviewMessage"]'));
              if (error_count > 0) {
				  e.preventDefault();
                return false;
              }else{
              	e.preventDefault(); StampedFn.submitForm($('form.new-review-form'));
                setTimeout(function(){
                  $(".stamped-thank-you").hide();
                  $('.template-product .stamped-summary-actions .review-button-wrap .stamped-summary-actions-newreview').css("display", "block");
                },12000);
              }
    });
}
//theme.error
theme.error = function(){
      if($(".errors").length > 0){
        var pageLoadCheckFormError = setInterval(function(){ 
          if($(".errors").length > 0){
            $(".errors").hide();
            clearInterval(pageLoadCheckFormError);
          }
        }, 10000);
      }
    }
// theme.init
theme.init = function() {
  theme.formValidation();
  theme.submitEvent();
  theme.error();
};

// Document ready after
document.addEventListener('readystatechange', event => {
  if (event.target.readyState === "complete") {
    if ($(".template-login").length > 0) {
      var loginPageFormSubmit = setInterval(function() {
        if ($("#customer_login[onsubmit]").length > 0) {
          $("#customer_login").removeAttr("onsubmit");
          clearInterval(loginPageFormSubmit);
        }
      }, 100);
      var loginPageFormSubmitRecover = setInterval(function() {
        if ($("[action='/account/recover'][onsubmit]").length > 0) {
          $("[action='/account/recover']").removeAttr("onsubmit");
          clearInterval(loginPageFormSubmitRecover);
        }
      }, 100);
    }
    
    if ($(".template-register").length > 0) {
      var registerPageFormSubmit = setInterval(function() {
        if ($("#create_customer[onsubmit]").length > 0) {
          $("#create_customer").removeAttr("onsubmit");
          clearInterval(registerPageFormSubmit);
        }
      }, 100);
    }
    if ($(".template-page .contact-form").length > 0) {
            var contactPageFormSubmit = setInterval(function() {
              if ($(".contact-form[onsubmit]").length > 0) {
                $(".contact-form").removeAttr("onsubmit");
                clearInterval(contactPageFormSubmit);
              }
            }, 100);
          }
    if ($(".footer__newsletter").length > 0) {
            var footerNewsletter = setInterval(function() {
             if ($(".footer__newsletter[onsubmit]").length > 0) {
                $(".footer__newsletter").removeAttr("onsubmit");
                clearInterval(footerNewsletter);
              }
            }, 100);
          }
  }
});
// document ready function
$(document).ready(function() {
  theme.init();

       let reviewvalidationInterval = setInterval(function(){
         if ( $('.custom-review-main .stamped-form-input').length > 0){
           $('.custom-review-main .stamped-form-input').removeAttr('required');
           $('.custom-review-main textarea.stamped-form-input').removeAttr('maxlength');
           $('.custom-review-main #reviewRating').removeAttr('required');
           $('.custom-review-main .stamped-form-contact-name').addClass('form-wrap');
           $('.custom-review-main .stamped-form-contact-email').addClass('form-wrap');
           $('.custom-review-main .stamped-form-review-title').addClass('form-wrap');
           $('.custom-review-main .stamped-form-review-body').addClass('form-wrap');
           $('.custom-review-main .stamped-form-review-rating').addClass('form-wrap');
           $('.custom-review-main input.stamped-form-input').after('<span class="form-error"></span>');
           $('.custom-review-main div.stamped-form-input').after('<span class="form-error"></span>');
		   $(".new-review-form").removeAttr("onsubmit");
           $('.custom-review-main .stamped-form-input-email')[0].type = 'text'; 
           clearInterval(reviewvalidationInterval);
         }
      },1000);
});
